<!-- Shared claw template for all klanken -->
<ng-template #klankTemplate let-klankData="klankData" let-draggable="draggable" let-clawOpen="clawOpen">
  <div class="hitbox" style="position: absolute; inset: 0; top: -55%"></div>
  <wk8-claw-back
    [opened]="clawOpen"
    [size]="clawSize()"
    class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[150%]"
    [ngClass]="{ 'claw-move-up': klankData.computedAnimationState === 'completing' }"
  ></wk8-claw-back>
  <wk8-paper-piece padding="SMALL" [style.font-size.px]="fontSize()">
    {{ klankData.klank }}
  </wk8-paper-piece>
  <wk8-claw-front
    [size]="clawSize()"
    class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[150%]"
    lightColor="blue"
    [opened]="clawOpen"
    [ngClass]="{ 'claw-move-up': klankData.computedAnimationState === 'completing' }"
  ></wk8-claw-front>
</ng-template>

<div #mechanic class="relative h-full select-none" style="position: relative; margin-left: 15%; height: 100%">
  <wk8-pipe-back class="absolute top-[24%] right-[15%] h-[45%] translate-x-full" />
  <wk8-conveyor-belt class="absolute top-[55%] block h-[8%] w-[90%]" />

  <!-- Klanken container - shared positioning for conveyor and exiting klanken -->
  <div class="klanken-container absolute right-[15%] bottom-[44.5%] w-4/5">
    <div class="klanken-list mx-auto flex w-full flex-row justify-center gap-6" wk8ReadFocus [style.min-height.px]="1.5 * fontSize()">
      @for (klankData of viewConveyorKlanken(); track klankData.uid; let i = $index) {
        <div class="klank-position relative">
          <!-- Regular conveyor klank -->
          <div
            cdkDrag
            [cdkDragDisabled]="hasPendingMutation()"
            class="klank relative overflow-visible"
            [attr.data-animation-state]="klankData.computedAnimationState"
            [style.transition-duration.ms]="klankData.animationConfig.duration"
            [style.transition-timing-function]="klankData.animationConfig.easing"
            (cdkDragMoved)="startDraggingConveyorKlank(i, $event)"
            (cdkDragReleased)="dragReleased($event)"
            (cdkDragStarted)="closeClaw(klankData.uid)"
            (cdkDragEnded)="openClaw(klankData.uid)"
            #conveyorKlank
          >
            <ng-container
              *ngTemplateOutlet="
                klankTemplate;
                context: {
                  klankData: klankData,
                  draggable: true,
                  clawOpen: klankData.clawOpen,
                }
              "
            ></ng-container>
          </div>

          <!-- Exiting klank for this position (if any) -->
          @for (exitingKlank of viewExitingKlanken(); track exitingKlank.uid) {
            @if (exitingKlank.originalIndex === i) {
              <div
                class="klank pointer-events-none absolute top-0 left-0 overflow-visible"
                [attr.data-animation-state]="exitingKlank.exitAnimationState"
              >
                <ng-container
                  *ngTemplateOutlet="
                    klankTemplate;
                    context: {
                      klankData: exitingKlank,
                      draggable: false,
                      clawOpen: false,
                    }
                  "
                ></ng-container>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
  <wk8-pipe-front class="absolute top-[24%] right-[15%] h-[45%] translate-x-full" />

  <!-- Screen -->
  <wk8-screen
    (submitted)="submitSolution()"
    (swapped)="undoMutation()"
    [numCompleted]="screenNumCompleted()"
    [numSteps]="screenNumSteps()"
    [submitButton]="submitButtonState()"
    swapButtonIcon="reset"
    [swapButton]="swapButtonState()"
    class="absolute right-0 bottom-0 -mr-1 -mb-2 h-2/5 w-[55%] -skew-1"
  >
    <wk8-panel-image #panelImage [word]="getNextWordData()!" style="display: block; width: 100%; height: 100%" />
  </wk8-screen>

  <!-- Klanken in the air -->
  <div class="klanken-in-air absolute top-[11%] left-0 w-4/5">
    <div class="klanken-list flex flex-row gap-2">
      @for (klankData of viewAirKlanken(); track klankData.uid; let i = $index) {
        <div
          cdkDrag
          [cdkDragDisabled]="hasPendingMutation()"
          class="klank relative overflow-visible"
          [attr.data-animation-state]="klankData.computedAnimationState"
          [style.transition-duration.ms]="klankData.animationConfig.duration"
          [style.transition-timing-function]="klankData.animationConfig.easing"
          (cdkDragMoved)="startDraggingKlank(i, $event)"
          (cdkDragReleased)="dragReleased($event)"
          (cdkDragStarted)="closeClaw(klankData.uid)"
          (cdkDragEnded)="openClaw(klankData.uid)"
        >
          <ng-container
            *ngTemplateOutlet="
              klankTemplate;
              context: {
                klankData: klankData,
                draggable: true,
                clawOpen: false,
              }
            "
          ></ng-container>
        </div>
      }
    </div>
  </div>
</div>

<wk8-ceiling class="pointer-events-none absolute top-0 -mt-1 select-none" />
